import $ from 'jquery';

$.notify = function (title, message, sticky) {
  if ($('#notifications').length === 0) {
    $('<ul id="notifications"></ul>').appendTo('body');
  }

  const notification = $(`
    <li class="hidden">
      <h3>${title}</h3>
      <p>${message}</p>
    </li>
  `)
    .on('click', function () {
      hideNotification($(this));
      return false;
    })
    .appendTo('#notifications');

  setTimeout(() => notification.removeClass('hidden'), 10);

  if (sticky !== true) {
    setTimeout(function () {
      hideNotification(notification);
    }, 5000);
  }
};

function hideNotification(notification) {
  notification.addClass('hidden');
  setTimeout(function () {
    notification.remove();
  }, 1500);
}

$(() => {
  const { notifications } = window;
  if (Array.isArray(notifications)) {
    notifications.map(({ title, message }) => {
      $.notify(title, message);
    });
  }
});
